import { Alert, AlertDescription, AlertIcon, AlertStatus, AlertTitle } from "@chakra-ui/react";
import { FC, ReactNode } from "react";

interface Props {
  status: AlertStatus;
  title: string;
  children: ReactNode;
}

const AlertBox: FC<Props> = ({ title, status, children }) => {
  return (
    <Alert status={status}>
      <AlertIcon />
      <AlertTitle>{title}</AlertTitle>
      <AlertDescription>{children}</AlertDescription>
    </Alert>
  );
};

export default AlertBox;
